/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_Air_Handler_Unit_HeadlineInputs */



/**
* | output |
* | --- |
* | "Supervise your air handling units" |
*
* @param {Go_Further_Air_Handler_Unit_HeadlineInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_air_handler_unit_headline = /** @type {((inputs?: Go_Further_Air_Handler_Unit_HeadlineInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Air_Handler_Unit_HeadlineInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Supervise your air handling units")
	return /** @type {LocalizedString} */ ("Supervisez vos centrales de traitement d'air")
});